module.exports = __webpack_public_path__ + "img/fx.fba3f389.png";